import React, { useEffect } from 'react';
import * as MetaPixelModule from 'meta-pixel';
import { SalesPage } from './pages/SalesPage';
const META_PIXEL_ID = '1041522335210960';
export function App() {
  useEffect(() => {
    const MetaPixel = (MetaPixelModule as any).MetaPixel ?? (MetaPixelModule as any).default ?? MetaPixelModule;
    try {
      const pixel = new MetaPixel(META_PIXEL_ID);
      if (typeof pixel.pageView === 'function') {
        pixel.pageView();
      }
    } catch {
      // no-op: pixel initialization failed silently
    }
  }, []);
  return <SalesPage data-id="element-0" />;
}